.sn-best-practices {
  &__left {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, xs); // 8px — Figma mobile gap between heading and intro text

    @include above($breakpoint-desktop) {
      gap: map-get($spacings, md); // 16px — Figma desktop
    }

    @include above($breakpoint-desktop-md) {
      max-width: 396px; // Figma desktop fixed left-column width
      flex-shrink: 0;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, xl); // 24px — Figma both mobile and desktop
    flex: 1;
  }

  &__item {
    display: flex;
    align-items: flex-start; // Figma: items-start — top edges of icon and content align
    gap: map-get($spacings, md); // 16px — Figma
  }

  &__check {
    flex-shrink: 0;
    color: var(--color-brand-primary-main); // brand color for the check icons
  }

  &__item-content {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, xs); // 8px — Figma gap between title and text inside an item
    color: var(--text-color-primary);
  }

  &__item-title {
    // Figma Heading/H9 — Graphik Bold 20px / 28px line-height
    font-family: Graphik, Arial, sans-serif; // TODO: no $font-family token — matches signnow theme heading font
    font-weight: 700;
    font-size: map-get($font-sizes, xl); // 20px
    line-height: 28px;

    h3,
    .me-heading {
      font: inherit;
      color: inherit;
      margin: 0;
    }
  }

  .me-heading--4 {
    // Figma Heading/H5 — Graphik Bold 36px / 48px line-height (same on desktop and mobile)
    font-size: map-get($font-sizes, 4xl); // 36px
    line-height: 48px;
  }

  .me-text {
    // Figma Paragraph/Body 2 — Open Sans Regular 16px / 24px line-height
    font-size: map-get($font-sizes, md); // 16px
    line-height: 24px;
  }
}
